import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import SupplierForm from '../form/supplier'
import {TableLegalRepresentativeWrapper} from './component/table/legalRepresentative'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {TabLavanderiaModel} from '../../../../../../models'
import ButtonClose from '../../../../../../components/UI/Button/IconButton'
import {TableEquipmentSuppliersWrapper} from './component/table/equipmentsuppliers'
const DetailSuppliersPanel = () => {
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLavanderia()

  const handleBack = () => {
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <div className='sdx_content_tab_panel'>
      {isDisabled && <ButtonClose onClick={handleBack} color='#283897' />}

      <Tabs className={'sdx_sub_react_tab_panel '}>
        <TabList className={'sdx_sub_tab_panel p-0'}>
          <Tab className={'sdx_sub_tab_panel_option'}>Actualizar Registro</Tab>
          {isAllowed('REPRESENTANTELEGAL/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Representante Legal</Tab>
          )}
          {isAllowed('EQUIPOPROVEEDORES/ACCESO') && (
            <Tab className={'sdx_sub_tab_panel_option'}>Equipo Proveedores</Tab>
          )}
        </TabList>
        <TabPanel>
          <SupplierForm />
        </TabPanel>
        {isAllowed('REPRESENTANTELEGAL/ACCESO') && (
          <TabPanel>
            <TableLegalRepresentativeWrapper />
          </TabPanel>
        )}
        {isAllowed('EQUIPOPROVEEDORES/ACCESO') && (
          <TabPanel>
            <TableEquipmentSuppliersWrapper />
          </TabPanel>
        )}
      </Tabs>
    </div>
  )
}

export default DetailSuppliersPanel
